@if (isReady && !showConfirmation) {
  <form [formGroup]="form">
    <div class="row">
      <div class="mb-3 col-12 col-lg-6">
        <label for="nom">Nom</label>
        <input class="form-control" id="nom" type="text" placeholder="Votre nom" readonly="readonly" value="{{ user.nom }}"/>
      </div>
      <div class="mb-3 col-12 col-lg-6">
        <label for="prenom">Prénom</label>
        <input class="form-control" id="prenom" type="text" readonly="readonly" placeholder="Votre prénom" value="{{ user.prenom }}"/>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 col-12 col-lg-6">
        <label for="objet">Objet *</label>
        <input class="form-control" [class.is-invalid]="f.objet?.invalid && (f.objet?.dirty || f.objet?.touched)" id="objet" type="text" formControlName="objet" placeholder="Objet de votre mail"/>
        <div class="invalid-feedback"> Champ requis</div>
      </div>
      <div class="mb-3 col-12 col-lg-6">
        <label for="adresseEmail">Email</label>
        <input class="form-control" id="adresseEmail" type="email" readonly="readonly" placeholder="Votre email" value="{{ user.adresseEmail }}"/>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 col-12 col-lg-6">
        <label for="destinataire">Destinataire *</label>
        <select class="form-control" id="destinataire" formControlName="destinataire">
          @for (email of emails; track email; let last = $last) {
            <option [value]="email.email" [selected]="last === true">
              {{email.name}}
            </option>
          }
        </select>
        <div class="invalid-feedback"> Champ requis</div>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 col-12">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="content" [placeholder]="'Votre message'"></ngx-editor>
      </div>
    </div>
    @if (form.valid) {
      <div id="submit" class="text-center">
        <button type="submit" (click)="confirmation()" class="btn btn-blue">Envoyer</button>
      </div>
    }
  </form>
}

@if (showConfirmation) {
  <div>
    <h5 class="text-center">Confirmer l'envoi du mail ?</h5>
    <div class="row">
      <div class="mb-3 col-12 text-end">
        <button type="button" class="btn btn-light me-1" (click)="dismiss()">Annuler</button>
        <button type="button" class="btn btn-blue me-1" [disabled]="clicked" (click)="send(); clicked=true;">Confirmer</button>
      </div>
    </div>
  </div>
}
